import React from "react";
import {
  Popover,
  PopoverHandler,
  PopoverContent,
  IconButton,
} from "@material-tailwind/react";
import Share from "./Share";
import { ShareIcon } from "@heroicons/react/24/outline";
export default function SharePopover({ isDark = true, link, dark = false }) {
  return (
    <Popover>
      <PopoverHandler>
        {dark ? (
          <IconButton
            variant="outlined"
            className="rounded-full bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-white transition-colors duration-200"
          >
            <ShareIcon className="h-6 w-6 text-white" />
          </IconButton>
        ) : isDark ? (
          <IconButton
            // color="black"
            variant="outlined"
            className="rounded-full bg-white border-black border  text-black"
          >
            <ShareIcon className="h-6 w-6 text-black" />
          </IconButton>
        ) : (
          <IconButton
            color="white"
            variant="outlined"
            className="rounded-full bg-white border-white text-white"
          >
            <ShareIcon className="h-6 w-6 text-black" />
          </IconButton>
        )}
      </PopoverHandler>
      <PopoverContent className="z-50">
        <Share link={link}></Share>
      </PopoverContent>
    </Popover>
  );
}
